import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../../../appConstants";
import { getToken } from "../../authentication";

export const debitIncentiveForCancelRequest = async (reqId,reqNumber,debitReason) => {
    try {
            const token = getToken();
            const url = buildUrl(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/operations/requests/debit/incentive`, {
                reqId: reqId ? reqId : undefined,
                reqNumber: reqNumber ? reqNumber : undefined,
                debit_reason: debitReason?debitReason: undefined,
            });
            const response = await fetch(url,
                {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            const res = await response.json();
            if (!response.ok) {
                throw (res.message || "Something went wrong while debit incentive");
            }
            return res;
    } catch (err) {
        throw (err)
    }
}